export const RoveroBrand = ({
  inverse = false,
  large = false,
}: {
  inverse?: boolean;
  large?: boolean;
}) => (
  <span
    className={`rovero-brand rovero-crm-brand ${inverse ? "rovero-brand-inverse" : ""} ${large ? "rovero-brand-large" : ""}`}
    role="img"
    aria-label="ROVERO CRM"
  >
    <svg
      className="rovero-crm-mark"
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        className="rovero-crm-mark-background"
        width="64"
        height="64"
        rx="16"
      />
      <rect
        className="rovero-crm-mark-card"
        x="10"
        y="16"
        width="12"
        height="32"
        rx="6"
      />
      <rect x="26" y="10" width="12" height="44" rx="6" fill="#C56A3D" />
      <rect
        className="rovero-crm-mark-card"
        x="42"
        y="16"
        width="12"
        height="32"
        rx="6"
      />
    </svg>
  </span>
);
